import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Report, ReportCreateParams, ReportQueryParams, ReportUpdateParams } from '../models/report.model';
import { ListResponse } from '../models/utility.model';
import { ReportGateway } from '../usecases/report.gateway';

@Injectable()
export class ReportService extends ReportGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listReports(params: ReportQueryParams): Observable<ListResponse<Report>> {
    return this._http.get<ListResponse<Report>>('api/vgs/reports', { params });
  }

  createReport(params: ReportCreateParams): Observable<Report> {
    return this._http.post<Report>('api/vgs/reports', params);
  }

  updateReport(reportId: string, params: ReportUpdateParams): Observable<Report> {
    return this._http.put<Report>(`api/vgs/reports/${reportId}`, params);
  }

  deleteReport(reportId: string): Observable<void> {
    return this._http.delete<void>(`api/vgs/reports/${reportId}`);
  }
}
